/**
 * Created by msacco on 6/24/16.
 */

angular
  .module('ui-ng-ax')

  .directive('phxAxTrackInputMethod', function () {
    return {
      restrict: 'A',
      link: function ($scope, $element) {
        $element.attr('data-whatinput','');
      }
    };
  })
  .factory('phxAxTrackInputMethod', function () {
    return _.merge(whatInput, {
      // extend whatInput methods
    });
  });


// WEBPACK FOOTER //
// phx_ax_track_input_method.js